// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"ComponentLoader_loaderOverlay__FssAb","spinner":"ComponentLoader_spinner__g1xHu","spin":"ComponentLoader_spin__soDmi"};